<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
     [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Assign {{ 'Components' | terminology | async }} to {{files?.length > 1 ? 'Files' : 'File'}}
                </h4>
                <button type="button" class="close pull-right" (click)="closeModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="medium-padding remove-margin">

                    <p>Use the search box to find {{ 'component' | terminology | async }}(s) to assign to <strong>{{files?.length == 1 ? files[0].fileName : 'the ' + files?.length + ' selected files'}}</strong></p>

                    <div>
                        <sp-typeahead-property-component
                            #componentTypeahead
                            [selectedPropertyId]="propertyId"
                            [selectedFiscalYear]="fiscalYear?.year"
                            (componentSelected)="addSelectedComponent($event)"
                        ></sp-typeahead-property-component>
                    </div>

                    <hr>

                    <div class="file-component-container">
                        <div class="text-muted">Existing {{ 'component' | terminology | async }} assignments (no change): </div>
                        <div *ngFor="let component of getCurrentUnchangedComponents()" class="badge badge-gray-light">
                            {{component.name}}
                            <span (click)="removeSelectedComponentFromCurrent(component)"><i class="fa fa-times"></i></span>
                        </div>
                        <div *ngIf="currentComponents == null || currentComponents?.length == 0" classs="text-muted italics">No {{ 'components' | terminology | async }} currently assigned to file(s)</div>
                    </div>

                    <div class="file-component-container" *ngIf="addedComponents?.length > 0">
                        <div class="text-muted">Added {{ 'component' | terminology | async }} assignments: </div>
                        <div *ngFor="let component of addedComponents" class="badge badge-green-light">
                            {{component.name}}
                            <span (click)="removeSelectedComponentFromAdded(component)"><i class="fa fa-times"></i></span>
                        </div>
                        <div *ngIf="addedComponents == null || addedComponents?.length == 0" classs="text-muted italics">No new {{ 'components' | terminology | async }} have been assigned</div>
                    </div>

                    <div class="file-component-container" *ngIf="removedComponents?.length > 0">
                        <div class="text-muted">Removed {{ 'component' | terminology | async }} assignments: </div>
                        <div *ngFor="let component of removedComponents" class="badge badge-red">
                            {{component.name}}
                            <span (click)="removeSelectedComponentFromRemoved(component)"><i class="fa fa-times"></i></span>
                        </div>
                        <div *ngIf="removedComponents == null || removedComponents?.length == 0" classs="text-muted italics">No {{ 'components' | terminology | async }} have been unassigned</div>
                    </div>

                </div>
            </div>
            <footer class="text-start">
                <button type="button" class="btn btn-cancel" (click)="closeModal()">Cancel</button>
                <button type="button" class="btn btn-success" (click)="assignComponent()">Update {{ 'Components' | terminology | async }}</button>
            </footer>
        </div>
    </div>
</div>
